import Vue from 'vue';

import API from './index';

const END_POINT = 'basket';

export default {
  async getOne(id): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/${id}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getOne`, err.response);
      throw err.response;
    }
  },
  async createForPickup(restaurantId): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/pickup/${restaurantId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/createForPickup`, err.response);
      throw err.response;
    }
  },
  async createForCurbside(restaurantId: number, requestModel: CurbsideRequestModel): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/curbside/${restaurantId}`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/createForCurbside`, err.response);
      throw err.response;
    }
  },
  async createForDelivery(deliveryAddress: DeliveryAddress): Promise<SetDeliveryAddressResponse> {
    try {
      return (await API.post(`${END_POINT}/delivery`, deliveryAddress)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/createForDelivery`, err.response);
      throw err.response;
    }
  },
  async updateBasketToDelivery(
    basketId: string,
    deliveryAddress: DeliveryAddress
  ): Promise<SetDeliveryAddressResponse> {
    try {
      return (await API.put(`${END_POINT}/${basketId}/delivery`, deliveryAddress)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/updateBasketToDelivery`, err.response);
      throw err.response;
    }
  },
  async addProduct(
    basketId: string,
    productRequest: ProductRequest,
  ): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/product`, productRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/addProduct`, err.response);
      throw err.response;
    }
  },
  async quickAddProduct(
    basketId: string,
    quickAddRequest: QuickAddRequest
  ): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/product/quickadd`, quickAddRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/product/quickadd`, err.response);
      throw err.response;
    }
  },
  async updateProduct(
    basketId: number,
    basketProductId: number,
    productRequest: ProductRequest,
  ): Promise<Basket> {
    try {
      return (await API.put(`${END_POINT}/${basketId}/product/${basketProductId}`, productRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/updateProduct`, err.response);
      throw err.response;
    }
  },
  async deleteProduct(
    basketId: string,
    basketProductId: string,
  ): Promise<Basket> {
    try {
      return (await API.delete(`${END_POINT}/${basketId}/product/${basketProductId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/deleteProduct`, err.response);
      throw err.response;
    }
  },
  async setCurbsideDetails(
    basketId: string,
    curbsideDetails: CurbsideRequestModel
  ): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/curbside`, curbsideDetails)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/curbside`, err.response);
      throw err.response;
    }
  },
  async setHandoffMethod(
    basketId: string,
    method: string
  ): Promise<any> {
    try {
      return (await API.put(`${END_POINT}/${basketId}/handoff/${method}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/handoff`, err.response);
      throw err.response;
    }
  },
  async setTimeWanted(
    basketId: string,
    timeWantedRequest: TimeWantedRequest | any = null,
  ): Promise<any> {
    try {
      return (await API.put(`${END_POINT}/${basketId}/timewanted`, timeWantedRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/timewanted`, err.response);
      throw err.response;
    }
  },
  async transferBasket(
    basketId: string,
    restaurantId: number,
  ): Promise<TransferBasketResponse> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/transfer/${restaurantId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/transfer`, err.response);
      throw err.response;
    }
  },
  async getUpsellItems(
    basketId: string
  ): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/${basketId}/upsell`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/upsell`, err.response);
      throw err.response;
    }
  },
  async addUpsellItems(
    basketId: string,
    items: BasketAddUpsellPostItem[]
  ): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/upsell`, items)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/upsell`, err.response);
      throw err.response;
    }
  },
  async addCoupon(
    basketId: string,
    couponCode: string
  ): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/coupon/${couponCode}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/coupon`, err.response);
      throw err.response;
    }
  },
  async removeCoupon(
    basketId: string
  ): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/${basketId}/coupon`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/coupon`, err.response);
      throw err.response;
    }
  },
  async addReward(
    basketId: string,
    membershipId: number,
    referenceId: string
  ): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/reward/${membershipId}/${referenceId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/reward`, err.response);
      throw err.response;
    }
  },
  async removeReward(
    basketId: string,
    rewardId: number
  ): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/${basketId}/reward/${rewardId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/reward`, err.response);
      throw err.response;
    }
  },
  async setTip(
    basketId: string,
    amount: number
  ): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/tip`, { amount: amount })).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/tip`, err.response);
      throw err.response;
    }
  },
  async validateBasket(
    basketId: string
  ): Promise<ValidateBasketResponse> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/validate`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/validate`, err.response);
      throw err.response;
    }
  },
  async placeOrder(
    basketId: string,
    submitRequest: SubmitBasketRequest
  ): Promise<OrderModel> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/submit`, submitRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/submit`, err.response);
      throw err.response;
    }
  },
  async placeOrderMultiPayment(
    basketId: string,
    submitRequestMultiPayment: SubmitBasketRequestMultiPayment
  ): Promise<OrderModel> {
    try {
      return (await API.post(`${END_POINT}/${basketId}/submit/multiplepayments`, submitRequestMultiPayment)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/submit/multiplepayments`, err.response);
      throw err.response;
    }
  },
  async createBasketFromPreviousOrder(orderRef: string, oloId: string): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/previous/${orderRef}/${oloId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/previous`, err.response);
      throw err.response;
    }
  },
  async createBasketFromFavoriteOrder(favoriteId: number): Promise<Basket> {
    try {
      return (await API.post(`${END_POINT}/favorite/${favoriteId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/favorite`, err.response);
      throw err.response;
    }
  }
}
